import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EOrderTypeValue } from 'v2/modules/sales-order/configs/sales-order.config';
import { DialogConfig, SnackBarConfig } from 'v2/modules/shared/configs';
import { trackByValue } from 'v2/modules/shared/util/track-by.util';

import { EOrderTransferStatus } from '../../interfaces/order-transfer.interface';
import { IOrderTransferInterface } from '../../interfaces/order-transfers.interface';
import { OrderTransferLineItemsComponent } from '../order-transfer-line-items/order-transfer-line-items.component';

interface IColumnConfig {
  id :string;
  label :string;
  visible :boolean;
}

@Component({
  selector: 'lum-order-transfer-table',
  templateUrl: './order-transfer-table.component.html',
  styleUrls: ['./order-transfer-table.component.scss'],
})
export class OrderTransferTableComponent implements OnChanges {
  @Input()
  columns :IColumnConfig[] = [];

  @Input()
  orderTransfers :IOrderTransferInterface[] = [];

  @Output()
  deleteOrderEvent :EventEmitter<IOrderTransferInterface> =
    new EventEmitter<IOrderTransferInterface>();

  private onDestroy$ = new Subject();
  orderTransferStatus = EOrderTransferStatus;
  eOrderTypeValue = EOrderTypeValue;
  trackByValue = trackByValue;

  constructor(
    private dialog :MatDialog,
    private router :Router,
    private snackBar :MatSnackBar,
  ) {}

  ngOnChanges({ orderTransfers } :SimpleChanges): void {
    if (orderTransfers?.currentValue) {
      this.transformAlternateIds();
    }
  }

  onShowOrderItems(orderTransfer :IOrderTransferInterface) :void {
    this.dialog
      .open(OrderTransferLineItemsComponent, {
        data: {
          orderTransfer,
        },
        width: DialogConfig.sizes.medium,
        maxHeight: '550px',
        disableClose: true,
      })
      .afterClosed()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe();
  }

  onValidateAction(order :IOrderTransferInterface, action :string) :void {
    if (
      !order.supplierPurchaseOrder ||
      (order.supplierPurchaseOrder &&
        !order.supplierPurchaseOrder.receivingReportRfq)
    ) {
      switch (action) {
        case 'edit':
          this.router.navigate(['/inventory/transfer-order/', order.id, 'edit']);
          break;
        case 'delete':
          this.deleteOrderEvent.emit(order);
          break;
        default:
          break;
      }
    } else {
      this.snackBar.open(
        'Transfer Orders with a Purchase Order Transaction and a Receiving Report Transaction cannot be deleted.',
        'Fail',
        {
          duration: SnackBarConfig.DEFAULT.duration,
        },
      );
    }
  }

  get columnAsObject() :any {
    const columns :any = {};
    this.columns.forEach((column :any) => {
      columns[column.id] = column;
    });

    return columns;
  }

  private transformAlternateIds(): void {
    this.orderTransfers.forEach(order => {
      if (order.supplierPurchaseOrder?.alternateIds?.length && !order.supplierPurchaseOrder.modelAlternateIds?.length) {
        order.supplierPurchaseOrder.modelAlternateIds = order.supplierPurchaseOrder.alternateIds.map(id => ({
          id: null,
          alternateId: id,
          type: null,
          createdAt: null,
          updatedAt: null
        }));
      }
    });
  }
}
